type FilterTags = {
  name: string;
  id: string;
};

// Returns a new object so React sees the change and the sources query refetches.
export const changeSourceGlobalSearch = (
  searchSubString: string,
  sourceFilter: any,
) => ({
  ...sourceFilter,
  search: searchSubString,
});

export const filterSourceUrl = (e: any, sourceFilter: any) => {
  let tempArray: FilterTags[] = sourceFilter.destination_url__in;
  if (tempArray.map((a) => a.id).includes(e.target.value)) {
    let removed: FilterTags[] = [];
    for (var item in tempArray) {
      if (tempArray[item].id !== e.target.value) removed.push(tempArray[item]);
    }
    sourceFilter[e.target.id] = removed;
  } else {
    let newTag = {
      name: e.target.name,
      id: e.target.value,
    };
    tempArray.push(newTag);
    sourceFilter[e.target.id] = tempArray;
  }
  return sourceFilter;
};

export const removeSourceFilterTag = (e: any, sourceFilter: any) => {
  if (sourceFilter.destination_url__in.map((a: any) => a.id).includes(e)) {
    let tempArray: FilterTags[] = sourceFilter.destination_url__in;
    let removed: FilterTags[] = [];
    for (var item in tempArray) {
      if (tempArray[item].id !== e) removed.push(tempArray[item]);
    }
    sourceFilter.destination_url__in = removed;
  }
  return sourceFilter;
};

export const resetSourceFilters = () => {
  return {
    destination_url__in: [],
    enabled: [],
    type__in: [],
    owner__in: [],
    ordering: '',
    search: '',
  };
};

export const formatSourceDatetime = (datetime: string, timezone: any) => {
  const date = new Date(datetime); // Assumed to be in UTC

  // Parse timezone offset
  const sign = timezone.value.startsWith('-') ? -1 : 1;
  const hours = parseInt(timezone.value.slice(1, 3), 10);
  const minutes = parseInt(timezone.value.slice(3, 5), 10) || 0;
  const offsetMilliseconds = sign * (hours * 60 + minutes) * 60 * 1000;

  const adjustedDate = new Date(date.getTime() + offsetMilliseconds);

  const weekdayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  const weekday = weekdayNames[adjustedDate.getUTCDay()];
  const month = monthNames[adjustedDate.getUTCMonth()];
  const day = String(adjustedDate.getUTCDate()).padStart(2, '0');
  const year = adjustedDate.getUTCFullYear();
  const hour = String(adjustedDate.getUTCHours()).padStart(2, '0');
  const minute = String(adjustedDate.getUTCMinutes()).padStart(2, '0');
  const second = String(adjustedDate.getUTCSeconds()).padStart(2, '0');

  return `${weekday}, ${month} ${day}, ${year}, ${hour}:${minute}:${second}`;
};
